<template>
  <div>
    <div ref="photoReportModal" class="modal modal-v modal-v--normal fade" id="photoReportModal" tabindex="-1" role="dialog" aria-labelledby="photoReportModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <form @submit.prevent="submit" novalidate>
            <input type="hidden" name="mediaId" value="">
            <div class="modal-body text-center">
              <h2 class="title title--medium mt-2 mt-md-0 mb-4">{{ trans.get('profile:show.report_photo_modal.header') }}</h2>
              <!--                            <p>{{ responseMessage }}</p>-->
              <div class="photo-report__reason">
                <div v-for="(violation, index) in violations" class="radio-item">
                  <input :id="'ritem'+index" v-model="violationReasonId" type="radio" class="form-check-input" :value="violation.id" required>
                  <label :for="'ritem'+index"> {{ violation.name }} </label>
                </div>
              </div>
              <!-- Validation message -->
              <p v-if="showValidationReason" class="text-danger">{{ trans.get('profile:show.report_photo_modal.choose_reason') }}</p>

              <div class="d-flex flex-column align-items-center justify-content-start">
                <button type="submit" class="button button__fill button__fill--gradient-purple mt-4 mb-3">{{ trans.get('profile:show.report_photo_modal.report_button') }}</button>
                <button type="button" class="button button__link" data-dismiss="modal">{{ trans.get('profile:show.report_photo_modal.close_button') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoReportModal',
  components: {},
  props: {},
  data() {
    return {
      open: false,
      mediaId: null,
      violationReasonId: null,
      showValidationReason: false,
      responseMessage: null,
      violations: [],
    };
  },
  computed: {},
  watch: {
    open(val) {
      if (val) {
        this.loadViolations();
        $(this.$refs.photoReportModal).modal('show');
      } else {
        $(this.$refs.photoReportModal).modal('hide');
      }
    },
  },
  methods: {
    submit() {
      if (this.violationReasonId) {
        axios.post(zRoute('ajax.violations.photo'), {
          media_id: this.mediaId,
          violation_reason_id: this.violationReasonId,
        })
          .then(response => {
            this.open = false;
            this.responseMessage = response.data.message;
            // this.$eventHub.$emit('ViolationSend');
          });
      } else {
        this.showValidationReason = true;
      }
    },
    loadViolations() {
      if (this.violations.length === 0) {
        axios.get(zRoute('ajax.violation_reasons.index', window.globals.violation_reason.type_image)).then(response => {
          this.violations = response.data.data;
        });
      }
    }
  },
  mounted() {
    let vm = this;

    this.$eventHub.$on('PhotoReportModalOpen', (mediaId) => {
      vm.open = true;
      vm.mediaId = mediaId;
    });

    $(this.$refs.photoReportModal).on('hidden.bs.modal', function (e) {
      vm.open = false;
    });
  }
};
</script>

<style scoped>

</style>
